export default "__VITE_ASSET__57b04ed6__"